import { useCallback } from "react";
import { useWebSocketContext } from "../providers/WebSocketContextProvider";

export default function useWebSocketCaller() {

  const {getStompClient} = useWebSocketContext();

  const sendMessage = useCallback((appEndPoint, msgObj) => {
    if (getStompClient()) {
      getStompClient().send('/app/'+appEndPoint, JSON.stringify(msgObj));
    }
    else {
      console.warn('stompClient not initialized. canceling send request for [endpoint: %s] [msgObj]', appEndPoint, JSON.stringify(msgObj));
    }
  }, [getStompClient]);


  return {
    sendMessage
  }
}
